import { ChevronUp, ChevronDown, ChevronsUpDown } from 'lucide-react';

export const SortableTh = ({ label, sortKey, sortConfig, onSort, className = '' }) => {
    const active = sortConfig?.key === sortKey;
    const Icon = !active ? ChevronsUpDown : sortConfig.direction === 'asc' ? ChevronUp : ChevronDown;

    return (
        <th className={className}>
            <button
                type="button"
                onClick={() => onSort(sortKey)}
                className={`inline-flex items-center gap-1 transition-colors hover:text-[#1B7EB5] ${active ? 'text-[#1B7EB5]' : ''}`}
                data-testid={`sort-${sortKey}`}
            >
                {label}
                <Icon className={`w-3.5 h-3.5 ${active ? 'opacity-100' : 'opacity-40'}`} />
            </button>
        </th>
    );
};
